export default __webpack_public_path__ + "static/media/126.34c9acfb.png";